import { useMemo } from "react";
import { useAppointmentTabCounts } from "@/domains/appointment/appointments/shared/hooks/use-appointment-tab-counts";

export interface AttentionCounts {
  /**
   * Total count of items requiring attention
   * Currently includes: unconfirmed appointments (requests)
   * Future: waitlist items when expanded
   */
  total: number;

  /**
   * Breakdown of attention items by category
   */
  breakdown: {
    unconfirmedAppointments: number;
    // Future: waitlistItems: number;
  };
}

/**
 * Hook to aggregate all attention-requiring items across the dashboard
 * Uses existing appointment tab counts to avoid additional API calls
 * Respects current worker filtering from UI store
 *
 * Currently tracks:
 * - Unconfirmed appointments (appointments with bookingStatus: "PENDING")
 *
 * Future extensibility:
 * - Waitlist items when wait list is expanded
 * - Other attention-requiring dashboard items
 */
export const useAttentionCounts = (): AttentionCounts => {
  const tabCounts = useAppointmentTabCounts();

  const counts = useMemo((): AttentionCounts => {
    // Unconfirmed appointments are tracked in the "requests" tab
    const unconfirmedAppointments = tabCounts?.requests || 0;

    // Future: Add waitlist items when expanded
    // const waitlistItems = tabCounts?.waitlist || 0;

    return {
      total: unconfirmedAppointments,
      breakdown: {
        unconfirmedAppointments,
        // Future: waitlistItems,
      },
    };
  }, [tabCounts?.requests]);

  return counts;
};
